export enum StoredDocumentValidType {
  JPG = "image/jpg",
  JPEG = "image/jpeg",
  PNG = "image/png",
  HEIC = "image/heic",
  TIFF = "image/tiff",
  GIF = "image/gif",
  PDF = "application/pdf",
  MSG = ".msg",
}
